import { render, staticRenderFns } from "./AttachDialog.vue?vue&type=template&id=f6532478"
import script from "./AttachDialog.vue?vue&type=script&lang=js"
export * from "./AttachDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports